import { API_URL } from "./config";
import React, {
  useEffect,
  useState,
} from "react";

import {
  useParams,
  useNavigate,
} from "react-router-dom";



const InviteHandler = () => {
  const { token } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(true);

  const [message, setMessage] =
    useState(
      "Processing invitation..."
    );

  useEffect(() => {
    processInvitation();
  }, []);

  const processInvitation =
    async () => {
      try {
        // ====================================
        // GET INVITATION DETAILS
        // ====================================
        setMessage(
          "Checking invitation..."
        );

        const inviteResponse =
          await fetch(
            `${API_URL}/invitation/${token}`
          );

        const inviteData =
          await inviteResponse.json();

        if (!inviteResponse.ok) {
          setMessage(
            inviteData.error ||
              "Invalid invitation"
          );

          setTimeout(() => {
            navigate("/");
          }, 2000);

          return;
        }

        const invitedEmail =
          inviteData.receiver_email;

        // ====================================
        // CHECK LOGGED USER
        // ====================================
        const user = JSON.parse(
          localStorage.getItem(
            "user"
          )
        );

        // ====================================
        // USER LOGGED IN
        // ====================================
        if (user?.email) {
          const loggedEmail =
            user.email.toLowerCase();

          const expectedEmail =
            invitedEmail.toLowerCase();

          // --------------------------------
          // WRONG ACCOUNT
          // --------------------------------
          if (
            loggedEmail !==
            expectedEmail
          ) {
            setMessage(
              `Switching account...
Please login with ${invitedEmail}`
            );

            // save invite data
            localStorage.setItem(
              "inviteToken",
              token
            );

            localStorage.setItem(
              "invitedEmail",
              invitedEmail
            );

            // logout current user
            localStorage.removeItem(
              "user"
            );

            localStorage.removeItem(
              "token"
            );

            setTimeout(() => {
              navigate("/login");
            }, 1500);

            return;
          }

          // --------------------------------
          // CORRECT USER -> ACCEPT INVITE
          // --------------------------------
          setMessage(
            "Accepting invitation..."
          );

          const response =
            await fetch(
              `${API_URL}/accept-invite/${token}`,
              {
                method: "POST",
                headers: {
                  "Content-Type":
                    "application/json",
                },
                body: JSON.stringify({
                  receiver_email:
                    user.email,
                }),
              }
            );

          const data =
            await response.json();

          if (!response.ok) {
            setMessage(
              data.error ||
                "Invitation failed"
            );

            setTimeout(() => {
              navigate("/");
            }, 2000);

            return;
          }

          // cleanup
          localStorage.removeItem(
            "inviteToken"
          );

          localStorage.removeItem(
            "invitedEmail"
          );

          setMessage(
            "✅ Invitation accepted successfully"
          );

          setTimeout(() => {
            navigate(
              "/dashboard"
            );
          }, 1200);
        }

        // ====================================
        // USER NOT LOGGED IN
        // ====================================
        else {
          localStorage.setItem(
            "inviteToken",
            token
          );

          localStorage.setItem(
            "invitedEmail",
            invitedEmail
          );

          setMessage(
            "Redirecting to login..."
          );

          setTimeout(() => {
            navigate("/login");
          }, 1000);
        }
      } catch (error) {
        console.error(
          "Invite error:",
          error
        );

        setMessage(
          "❌ Something went wrong"
        );

        setTimeout(() => {
          navigate("/");
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card shadow p-5 text-center"
        style={{
          width: "420px",
          borderRadius: "20px",
        }}
      >
        <h3 className="mb-3">
          I-PQSign Invitation
        </h3>

        {loading ? (
          <>
            <div
              className="spinner-border text-primary mb-3"
              role="status"
            >
              <span className="visually-hidden">
                Loading...
              </span>
            </div>

            <p>{message}</p>
          </>
        ) : (
          <p>{message}</p>
        )}
      </div>
    </div>
  );
};

export default InviteHandler;